export default "__VITE_ASSET__ZwuXYYjW__"